<template>
  <div>
    <!-- jd modal for recruiter -->
    <b-modal
      id="addjdmodal"
      centered
      hide-footer
      hide-header
      size="lg"
      no-close-on-backdrop
      :visible="showModal"
      @hidden="
        from === 'talentpool' ? $emit('candidates-selected') : closeaddjdmodal()
      "
    >
      <b-overlay :show="showLoader" rounded="sm">
        <div class="cs-modal-header">
          <div>
            {{
              showJobOppurtunity
                ? "Send Job Opportunity"
                : " Add Candidates to Job"
            }}
          </div>
          <div
            @click="
              from === 'talentpool'
                ? $emit('candidates-selected')
                : closeaddjdmodal()
            "
          >
            <img
              class="rotate-on-hover"
              src="../../assets/img/accessconnew/blueCross.svg"
              alt=""
            />
          </div>
        </div>
        <div class="tp-modal-overflow-2">
          <b-row>
            <b-col :cols="columsCount">
              <div class="tp-add-cand-left" style="height: calc(100vh - 285px)">
                <div class="search-bar" style="width: 100%">
                  <img
                    class="searchicon"
                    src="../../assets/img/search-bar-icon.svg"
                    alt=""
                  />
                  <b-form-input
                    class="search-input"
                    placeholder="Search in Customers"
                    type="search"
                    v-model.trim="searchCustomer"
                    @update="customerSearch"
                    debounce="500"
                    :disabled="showLoader"
                  ></b-form-input>
                </div>
                <hr />
                <div class="ct-table-bold-txt-3">Customers</div>
                <div
                  style="height: 500px"
                  v-if="
                    allcustomerDetails &&
                    allcustomerDetails.length == 0 &&
                    searchCustomer != ''
                  "
                  class="
                    text-center
                    d-flex
                    flex-column
                    align-items-center
                    justify-content-center
                    tp-cust-name-overflow-2
                  "
                >
                  <img src="../../assets/img/nofoldersearch.svg" alt="" />
                  <div class="mt-3 ml-3 remarks-ops-status">
                    No customers found for "<b>{{ searchCustomer }}</b
                    >"
                  </div>
                </div>
                <div
                  v-else
                  class="tp-cust-name-overflow-2 mt-1"
                  @scroll="scrollCustomers"
                >
                  <div
                    v-for="(i, index) in allcustomerDetails"
                    :key="index"
                    :class="
                      selectedCustomer.customerID == i.customerID
                        ? 'tp-cust-back-2 mt-2 mb-2 mr-1'
                        : 'tp-cust-back-white-2 mt-2 mb-2 mr-1 pointer'
                    "
                    @click="
                      (selectedCustomer = i),
                        (searchJob = ''),
                        getJobs(),
                        (selectedJob = {}),
                        (selectOption = [])
                    "
                  >
                    <span class="vc-black-txt"> {{ i.name }}</span>
                  </div>
                  <div
                    style="margin: auto"
                    v-if="jdLoader"
                    class="d-flex justify-content-center mt-3 mb-1"
                  >
                    <b-spinner small label="Loading..."></b-spinner>
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              cols="6"
              class="pl-0"
              :style="
                allcustomerDetails &&
                allcustomerDetails.length === 0 &&
                searchCustomer !== '' &&
                selectedjd.length == 0
                  ? 'display: none;'
                  : ''
              "
            >
              <div
                style="height: calc(100vh - 285px)"
                class="
                  d-flex
                  flex-column
                  align-items-center
                  justify-content-center
                  tp-add-cand-left
                "
                v-if="Object.keys(selectedCustomer).length == 0"
              >
                <img src="../../assets/nocustomerselected.svg" alt="" />
                <div class="text-center pff-add-left-main-headings mt-3">
                  Click on the customer name <br />
                  to view Jobs
                </div>
              </div>

              <div
                class="tp-add-cand-left d-flex flex-column"
                :class="
                  (Object.keys(selectedCustomer).length == 0 &&
                    searchCustomer != '') ||
                  (selectedjd.length &&
                    Object.keys(selectedCustomer).length == 0)
                    ? 'justify-content-end'
                    : 'justify-content-between'
                "
                v-if="
                  alljobDetails.length != 0 ||
                  Object.keys(selectedCustomer).length != 0 ||
                  Object.keys(selectedJob).length != 0
                "
                style="height: calc(100vh - 285px)"
              >
                <div
                  class="adjd-white-card"
                  v-if="
                    alljobDetails.length != 0 ||
                    Object.keys(selectedCustomer).length != 0
                  "
                >
                  <div class="ct-table-bold-txt-3 px-2">Jobs</div>
                  <div class="search-bar mt-1" style="width: 100%">
                    <img
                      class="searchicon"
                      src="../../assets/img/search-bar-icon.svg"
                      alt=""
                    />
                    <b-form-input
                      style="border-radius: 11px"
                      class="search-input"
                      placeholder="Search in Jobs"
                      v-model.trim="searchJob"
                      @update="getJobs"
                      debounce="500"
                      type="search"
                    ></b-form-input>
                  </div>

                  <div class="tp-JDs-card mx-1">
                    <div
                      class="overflow-auto"
                      :style="
                        showJobOppurtunity &&
                        Object.keys(selectedJob).length != 0 &&
                        'height: calc(100vh - 503px) !important;'
                      "
                      style="height: calc(100vh - 446px)"
                      v-if="alljobDetails == 0 && searchJob != ''"
                    >
                      <div
                        class="
                          h-100
                          d-flex
                          flex-column
                          align-items-center
                          justify-content-center
                          wb-nocard-selected-font
                          w-100
                        "
                      >
                        <div class="w-100 wordbreak text-center">
                          No job found for "<b>{{ searchJob }}</b
                          >"
                        </div>
                      </div>
                    </div>
                    <div
                      class="new-center-radio tp-jd-card-overflow"
                      v-else
                      :style="
                        showJobOppurtunity &&
                        Object.keys(selectedJob).length != 0 &&
                        'max-height: calc(100vh - 503px) !important;'
                      "
                    >
                      <b-form-radio
                        v-for="(job, index) in alljobDetails"
                        :key="job.jobID"
                        :value="job"
                        :disabled="job.notEnabled"
                        v-model="selectedJob"
                        :style="
                          index == 0 ? 'margin-top: 9px' : 'margin-top: 12px'
                        "
                        class="wordbreak"
                      >
                        {{ job.title }}
                      </b-form-radio>
                    </div>
                  </div>
                </div>
                <div>
                  <div
                    class="
                      d-flex
                      align-items-center
                      tp-side-modal-collapse-card
                      mt-2
                    "
                  >
                    <div class="ct-table-bold-txt-3 w-60">Selected Job:</div>

                    <div
                      :class="
                        Object.keys(selectedJob).length != 0
                          ? 'new-txt-jobs-selected'
                          : 'new-text-jobs'
                      "
                      class="ml-2 w-40 text-truncate text-right"
                    >
                      {{
                        Object.keys(selectedJob).length != 0
                          ? selectedJob.title
                          : "No jobs selected"
                      }}
                    </div>
                  </div>
                  <div
                    class="
                      tp-side-modal-collapse-card
                      mt-3
                      d-flex
                      align-items-center
                    "
                    v-if="showJobOppurtunity && Object.keys(selectedJob).length"
                  >
                    <div class="ct-table-bold-txt-3 w-40">Send via:</div>
                    <div
                      class="
                        common-single-checkbox
                        d-flex
                        align-items-center
                        w-60
                        text-right
                        justify-content-end
                      "
                    >
                      <b-form-checkbox
                        v-for="option in mailToggleOptions"
                        v-model="selectOption"
                        :key="option.value"
                        :value="option.value"
                      >
                        <div
                          class="checkbox-text"
                          :class="
                            mailToggleOptions.length > 1 &&
                            option.text == 'Mail'
                              ? 'mr-4'
                              : 'mr-0'
                          "
                          style="margin-top: 2px"
                        >
                          {{ option.text }}
                        </div>
                      </b-form-checkbox>
                    </div>
                  </div>

                  <!-- <b-collapse v-model="showselectedjobs">
                    <hr class="mt-2 mb-2" />
                    <div class="adjd-below-overflow">
                      <div
                        class="
                          d-flex
                          justify-content-between
                          align-items-center
                          p-1
                        "
                      >
                        <div class="tp-checkbox-text">
                          {{ selectedJob.title }}
                        </div>
                        <div @click="removeJd(index)" class="pointer">
                          <img
                            v-b-tooltip.hover.left="'Remove JD'"
                            src="../../assets/talentpool/cancelround.svg"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </b-collapse> -->
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div
          class="
            d-flex
            align-items-center
            justify-content-end
            border-top
            pt-2
            pb-3
            pr-4
            bluebtn
          "
        >
          <b-button
            class="acs-cancelBtn-modal mr-3 mt-1"
            @click="
              from === 'talentpool'
                ? $emit('candidates-selected')
                : closeaddjdmodal()
            "
            >Cancel</b-button
          >

          <b-button
            @click="!showJobOppurtunity ? showAddCand() : sendJob()"
            :disabled="
              (selectOption.length == 0 && showJobOppurtunity) ||
              !Object.keys(selectedJob).length
            "
            class="acs-addBtn-modal mt-1"
            :class="!showJobOppurtunity ? 'w-95px ' : ''"
            >{{ showJobOppurtunity ? "Send Now" : "Add" }}</b-button
          >

          <!-- <div class="relativeclass ml-3" style="width: 140px">
            <b-button
              class="acs-addBtn-modal w-100 mt-1 p-0"
              style="height: 29px"
              @click="mailToggle = !mailToggle"
            >
              <div>Trigger Mail</div>
              <div class="mx-2">
                <img src="./../../assets/img/button-white-line.svg" alt="" />
              </div>
              <div>
                <img src="./../../assets/img/button-right-arrow.svg" alt="" />
              </div>
            </b-button>
            <div
              v-if="mailToggle"
              class="
                selectCustom-dropdown
                pointer
                newManage-checkbox
                selectCustom-dropdown-text
                d-flex
                w-100
              "
              style="top: -85px"
            >
              <b-form-checkbox-group
                :options="mailToggleOptions"
                class="w-100 selectCustom-dropdown-innerContent"
                disabled-field="notEnabled"
                value-field="value"
                text-field="text"
                v-model="selectOption"
                :class="
                  selectOption !== ''
                    ? 'selectCustom-dropdown-innerContent-selected'
                    : ''
                "
              ></b-form-checkbox-group>
            </div>
            <div
              class="newInt-radio-dropdown p-0"
              v-if="mailToggle"
              style="top: -65px"
            >
              <b-form-group class="sec-mcq-datacard">
                <b-form-radio-group
                  class="
                    newInt-radio-dropdown-inner-content
                    w-100
                    relativeclass
                  "
                  size="sm"
                  :options="mailToggleOptions"
                  @change="mailToggle = false"
                  buttons
                  stacked
                >
                </b-form-radio-group>
              </b-form-group>
            </div>
          </div> -->
        </div>
      </b-overlay>
    </b-modal>
    <AddToJDSuccessSingle
      v-if="showAddToJDSuccessSingle"
      :showAddToJDSuccessSingle="showAddToJDSuccessSingle"
      :selectedjd="selectedjobs"
      :candidateSelectedToThirdParty="candidateSelectedToThirdParty"
      @hide-single-cand-jd-modal="
        (showAddToJDSuccessSingle = false), clearaddjdmodal()
      "
    />
    <AddToJDSuceessMultiple
      v-if="showCandTPModal"
      :showCandTPModal="showCandTPModal"
      :from="from"
      :selectedjd="selectedjobs"
      :candidateSelected="candidateSelected"
      :posType="posType"
      :candPosData="candPosData"
      :candidateSelectedToThirdParty="candidateSelectedToThirdParty"
      @hide-cand-tp-modal="(showCandTPModal = false), clearaddjdmodal()"
    />
    <AssignSinglePositionID
      v-if="showSingleAssign"
      :showSingleAssign="showSingleAssign"
      :positionIDs="positionIDs"
      :candidate="items[0]"
      @add-to-job="addSingleCand"
      @close-modal="closeSingleAssign"
    />

    <AddCandidatesToJob
      v-if="showAddCands"
      :showAddCands="showAddCands"
      @go-to-position="gotoPosition"
      @close-modal="closeAddCandidates"
    />

    <AssignPositionID
      v-if="showAssignPositionIDs"
      :showAssignPositionIDs="showAssignPositionIDs"
      :items="items"
      :positionIDOptions="positionIDOptions"
      @set-position="setPosition"
      @add-cand-to-job="addSingleCand"
      @close-modal="closeAssignPositionIDs"
    />
  </div>
</template>

<script>
import {
  getSingleJob,
  getCustomer,
  addJobOppurtunity,
  getMyPositionID,
  getCandidateDetails,
} from "../../utils/apiFunctions.js";
import toast from "../../components/mixin/toast";
import AddToJDSuccessSingle from "./AddToJDSuccessSingle.vue";
import AddToJDSuceessMultiple from "./AddToJDSuceessMultiple.vue";
import AssignSinglePositionID from "../../components/Kanban/modal/AssignSinglePositionID.vue";
import AddCandidatesToJob from "../../components/Kanban/modal/AddCandidatesToJob.vue";
import AssignPositionID from "../../components/Kanban/modal/AssignPositionID.vue";
import { mapGetters } from "vuex";

export default {
  name: "AddtoJDModal",
  props: {
    showJobOppurtunity: Boolean,
    candidateSelected: Array,
    candidateSelectedToThirdParty: Object,
    from: String,
    profileInfo: Object,
    showModal: Boolean,
    isSingle: Boolean,
  },
  mixins: [toast],
  components: {
    AddToJDSuccessSingle,
    AddToJDSuceessMultiple,
    AssignSinglePositionID,
    AddCandidatesToJob,
    AssignPositionID,
  },
  data() {
    return {
      // ARRAYS
      items: [],
      positionIDOptions: [],
      positionIDs: [],
      candPosData: {},
      posType: null,
      alljobDetails: [],
      candidateData: [],
      selectedjd: [],
      selectedJob: {},
      selectedjobs: [],
      allcustomerDetails: [],
      mailToggleOptions: [
        { text: "Mail", value: "email" },
        // { text: "WhatsApp", value: "whatsApp" },
      ],
      selectOption: [],

      //   STRINGS
      sortOrder: "-1",
      searchCustomer: "",
      sortColumn: "createdAt",
      statusType: "1",
      selectedCustomer: {},
      status: "3",
      searchJob: "",

      // BOOLEAN
      mailToggle: false,
      showselectedjobs: false,
      showLoader: false,
      jdLoader: false,
      showAddToJDSuccessSingle: false,
      showCandTPModal: false,
      showSingleAssign: false,
      showAddCands: false,
      showAssignPositionIDs: false,

      // NUMBERS
      jdCount: 14,
      jdtotalData: null,
      jdPageEnd: null,
      timer: null,
      page: 0,
      type: 1,
    };
  },
  watch: {
    allcustomerDetails: function () {
      this.handleConditionChange();
    },
  },
  created() {
    this.showLoader = true;
    if (this.roles.includes("GET_VENDOR_DASHBOARD")) {
      this.getVendors();
    } else {
      this.getCustomers();
    }
    if (["Bookmark", "TalentPool"].includes(this.$route.name))
      this.getCandidateDetails();
  },
  computed: {
    ...mapGetters("jobDescriptionVUEX", {
      customerDetail: "getCustomerDetail",
    }),
    columsCount() {
      if (
        this.allcustomerDetails &&
        this.allcustomerDetails.length === 0 &&
        this.searchCustomer !== "" &&
        this.selectedjd.length === 0
      ) {
        return 12;
      } else {
        return 6;
      }
    },
    ...mapGetters(["roles"]),
  },
  methods: {
    async gotoPosition(value) {
      if (value == 2) {
        if (this.items.length > 1) {
          this.items.forEach((obj) => (obj.positionID = this.positionIDs[0]));
          this.positionIDOptions = this.positionIDs;
          this.showAssignPositionIDs = true;
        } else {
          this.showSingleAssign = true;
        }
      } else {
        this.posType = "automatic";
        this.addToJd();
        // this.showCandTPModal = true;
        // this.addCandidate("automatic");
        // this.addCandsToJob('automatic');
      }
    },
    setPosition(data) {
      this.items.map((obj) => {
        if (obj.email == data.item.email) {
          obj.positionID = data.value;
        }
      });
      this.$forceUpdate();
    },
    checkAndClose() {
      this.closeAddCandidates();
      this.closeSingleAssign();
      this.closeAssignPositionIDs();
    },
    closeAssignPositionIDs() {
      this.showAssignPositionIDs = false;
      this.posType = null;
    },
    closeSingleAssign() {
      this.showSingleAssign = false;
      this.posType = null;
      this.candPosData = {};
    },
    addSingleCand(cand) {
      this.items = cand;
      this.posType = "manual";
      this.items.map((obj) => {
        this.candPosData[obj.candidateID] = obj.positionID;
      });
      this.addToJd();
      // this.showCandTPModal = true;
      // this.addCandidate("manual");
      // this.addCandsToJob();
    },
    closeAddCandidates() {
      this.showAddCands = false;
      this.posType = null;
    },
    showAssignModal(cand) {
      this.items.push(cand);
      this.showSingleAssign = true;
    },
    async showAddCand() {
      if (["Bookmark", "TalentPool"].includes(this.$route.name)) {
        await this.getMyPositionIDs();
        if (this.positionIDs.length > 1) {
          this.items = this.candidateData;
          this.showAddCands = true;
        } else {
          // if the recruiter have only one position id
          this.posType = "automatic";
          this.addToJd();
        }
      } else {
        this.addToJd();
      }
    },
    async sendJob() {
      try {
        let payload = {
          candidateIDs: this.candidateSelected,
          jobID: this.selectedJob.jobID,
          trigggerOptions: this.selectOption,
        };
        const response = await addJobOppurtunity(payload);
        if (response.status == 200) {
          this.successModal("Sent job successfully");

          this.$emit("close-modal");
        } else {
          this.errorModal("Something went wrong");
        }
      } catch (e) {
        this.errorModal("Something went wrong");
      }
    },
    addToJd() {
      this.selectedjobs.push(this.selectedJob.jobID);
      this.isSingle
        ? (this.showAddToJDSuccessSingle = true)
        : (this.showCandTPModal = true);
    },
    closeaddjdmodal() {
      this.$store.commit("cvSearchVUEX/setJobIDs", []);
      this.clearaddjdmodal();
    },
    handleConditionChange() {
      if (
        this.allcustomerDetails &&
        this.allcustomerDetails.length === 0 &&
        this.searchCustomer !== ""
      ) {
        this.searchJob = "";
      }
    },
    async getMyPositionIDs() {
      try {
        let payload = {
          type: 1,
          jobID: this.selectedJob.jobID,
          lead: this.customerDetail.lead,
        };
        const res = await getMyPositionID(payload);
        if (res.status == 200) {
          this.positionIDs = res.data.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getCandidateDetails() {
      try {
        let payload = {
          candidateIDs: this.candidateSelected,
        };
        const res = await getCandidateDetails(payload);
        if (res.status == 200) {
          this.candidateData = res.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
    async getCustomers() {
      try {
        let payload = {
          searchQuery: this.searchCustomer,
          sortColumn: this.sortColumn,
          sortOrder: this.sortOrder,
          type: this.type,
          page: this.page,
          count: this.jdCount,
          popup: true,
        };

        if (payload.searchQuery == "") {
          delete payload.searchQuery;
        }

        let res = await getCustomer(payload);
        if (res.status == 200) {
          this.jdtotalData = res.data.data.total;
          if (this.page == 0) {
            this.allcustomerDetails = res.data.data.data;
          } else {
            this.allcustomerDetails = [
              ...this.allcustomerDetails,
              ...res.data.data.data,
            ];
          }
          this.jdPageEnd = res.data.data.pageEnd;
          if (res.data.data.total == res.data.data.pageEnd) {
            this.jdLoader = false;
          } else {
            this.jdLoader = true;
          }
          if (this.searchCustomer == "" && this.selectedjd.length > 1) {
            await this.getJobs();
          }
          this.selectedJob = {};
          this.$emit("getCustomers");
          this.showLoader = false;
        }
      } catch (err) {
        this.showLoader = false;
        console.error(err);
      }
    },
    async getJobs() {
      try {
        this.showLoader = true;
        let data = {
          type: this.statusType,
          customerID: this.selectedCustomer.customerID,
          sortBy: this.sortColumn,
          order: this.sortOrder,
          searchQuery: this.searchJob,
          status: this.status,
          page: this.page,
          count: this.count,
          lead: this.selectedCustomer.lead,
          addToJD: true,
        };

        if (data.status == "") {
          delete data.status;
        }
        if (data.searchQuery == "") {
          delete data.searchQuery;
        }
        const res = await getSingleJob(data);
        if (res.status == 200) {
          this.showLoader = false;
          this.alljobDetails = res.data.data;
          if (this.$route.query.from == "kanban" && this.$route.query.jobID) {
            this.alljobDetails = this.alljobDetails.filter(
              (obj) => obj.jobID != this.$route.query.jobID
            );
          }
        }
      } catch (error) {
        this.showLoader = false;
        throw new Error(`Failed! status:${error.status}`);
      }
    },
    removeJd(index) {
      this.selectedjd.splice(index, 1);
    },
    // Function to handle scrolling down the courses section
    scrollCustomers(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      const threshold = 50;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - threshold;

      if (isNearBottom) {
        if (this.checkbetween(this.jdPageEnd, 0, this.jdtotalData)) {
          this.page++;
          this.getCustomers();
        }
      }
    },
    checkbetween(x, min, max) {
      return x > min && x < max;
    },
    customerSearch() {
      this.page = 0;
      this.showLoader = true;
      this.getCustomers();
      if (Object.keys(this.selectedCustomer).length != 0) {
        this.selectedCustomer = {};
        this.alljobDetails = [];
      }
    },
    clearaddjdmodal() {
      this.selectedjd = [];
      this.alljobDetails = [];
      this.selectedCustomer = {};
      this.searchCustomer = "";
      this.page = 0;
      this.jdLoader = false;
      this.searchJob = "";
      this.$emit("close-modal");
    },
  },
};
</script>

<style scoped>
.addmodal-hr {
  margin-bottom: 0rem !important;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.tp-top-card-red {
  height: 10px;
  background: #ff4752;
  border-radius: 5px 5px 0px 0px;
}

.new-text-jobs {
  font-family: "Lato", sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  color: #8c8c8c;
}

.new-txt-jobs-selected {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #000000;
}

.checkbox-text {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: #3a3c40;
}
</style>
